import type { MutationHookOptions } from '@apollo/client'
import {
  CreateTeamDocument,
  CreateTeamMutation,
  CreateTeamMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>
export type NewTeam = Omit<CreateTeamMutation['teamsMutations']['createTeamsTeam'], 'errors'>
export const useCreateTeam = (options?: Options) => {
  const [createTeam, { loading }] = useMutation(CreateTeamDocument, {
    ...options,
    extractorFn: (data) => data.teamsMutations.createTeamsTeam,
  })

  return {
    loading,
    create(variables: CreateTeamMutationVariables) {
      return createTeam({
        variables: variables,
      })
    },
  }
}
